import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-radial-stars" data-id="element-186">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-187">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-188">
          <div className="max-w-2xl" data-id="element-189">
            <FadeIn delay={0.1} data-id="element-190">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium leading-tight mb-6 text-glow" data-id="element-191">
                El Protocolo del Reset Circadiano: Cómo Volver a Dormir 7 Horas
                Seguidas Después de los 50
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-192">
              <p className="text-xl md:text-2xl text-gold-400 font-serif italic mb-8" data-id="element-193">
                (Sin Pastillas ni Resacas)
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-194">
              <p className="text-body-lg text-cream-muted mb-10" data-id="element-195">
                El método biológico diseñado específicamente para adultos que
                están cansados de despertar a las 3 AM y mirar el techo con
                frustración.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-196">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-197">
                <Button href="#quiero-bonos" className="w-full sm:w-auto" data-id="element-198">
                  Quiero Dormir Mejor
                </Button>
                <div className="flex items-center text-sm text-cream-muted mt-2 sm:mt-0" data-id="element-199">
                  <ShieldCheckIcon className="w-4 h-4 text-gold-500 mr-2" data-id="element-200" />
                  <span data-id="element-201">Acceso inmediato y seguro</span>
                </div>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.5} direction="left" className="relative" data-id="element-202">
            <div className="relative rounded-lg overflow-hidden box-glow border border-navy-700" data-id="element-203">
              <div className="absolute inset-0 bg-navy-900/20 mix-blend-overlay z-10" data-id="element-204"></div>
              <img src="https://cdn.magicpatterns.com/uploads/wB2NqxC7n7PErbmFKi79f4/FOTO_SUENO_PROFUNDO_.png" alt="Protocolo de Sueño Profundo 50+ en tablet y móvil" className="w-full h-auto object-cover relative z-0" data-id="element-205" />
            </div>
            {/* Subtle decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gold-500/10 rounded-full blur-2xl" data-id="element-206"></div>
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-navy-700/50 rounded-full blur-2xl" data-id="element-207"></div>
          </FadeIn>
        </div>
      </div>
    </section>;
}